export const digitsOnly = (value) =>
  String(value || "").replace(/\D/g, "");

/** True when value is a BR local number missing DDD (8 or 9 digits, or 55+local without DDD). */
export const needsBrazilianAreaCode = (value) => {
  const d = digitsOnly(value);
  if (!d) return false;
  // Complete international BR: 55 + DDD(2) + 8/9 subscriber digits
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) return false;
  // DDD + local without country (10/11) — has area code; not this error
  if (!d.startsWith("55") && (d.length === 10 || d.length === 11)) return false;
  // Local only (no DDD)
  if (d.length === 8 || d.length === 9) return true;
  // 55 + local without DDD → 10 or 11 digits starting with 55
  if (d.startsWith("55") && (d.length === 10 || d.length === 11)) return true;
  return false;
};

/** Strip leading 55 if present so UI/local part is subscriber digits only. */
export const extractBrazilianLocalSubscriber = (value) => {
  const d = digitsOnly(value);
  if (d.startsWith("55") && (d.length === 10 || d.length === 11)) return d.slice(2);
  return d;
};

/**
 * Compose E.164-ish BR digits for CheckContactNumber.
 * ddd: exactly 2 digits, 11–99; local: 8 or 9 digits (after extractBrazilianLocalSubscriber).
 */
export const composeBrazilianNumber = (ddd, local) => {
  const dddDigits = digitsOnly(ddd);
  const localDigits = extractBrazilianLocalSubscriber(local);
  if (!/^[1-9][0-9]$/.test(dddDigits)) {
    throw new Error("ERR_INVALID_AREA_CODE");
  }
  if (!(localDigits.length === 8 || localDigits.length === 9)) {
    throw new Error("ERR_INVALID_LOCAL_NUMBER");
  }
  return `55${dddDigits}${localDigits}`;
};
